/* ============================================================
   Wyld Chics — Build your pack   (sections/wc-pack-builder.liquid)

   No size to choose first (Jonathan, 2026-09-25: "the pack options should
   change automatically as they add more"). Picks are a list of variant ids
   in tap order (a style can repeat). The 3 / 5 / 7 cards are milestones:
   the highest one at or under the count is the current rate, every card
   at or under the count lights up, and crossing a line plays a short
   "Unlocked" moment on that card. A tap on a card only sets the goal the
   slots count toward. Add = one /cart/add.js with every pick, then the
   theme's afteradditem event so drawer, badge and strip refresh, and the
   drawer opens (same contract as wc-fbt.js). Shopify applies the rate in
   the cart through the automatic discounts; this script shows the maths.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-wc-pack]');
  if (!root) return;
  document.body.classList.add('wc-pack-page');

  // the theme's header overlays product templates (sticky, no height of its own); pad the page by its real height
  function padTop() {
    var h = document.querySelector('.section-site-header header, .section-site-header');
    if (!h) return;
    var r = h.getBoundingClientRect(), bottom = r.height;
    h.querySelectorAll('img, svg').forEach(function (el) { var b = el.getBoundingClientRect().bottom - r.top; if (b > bottom && b < 260) bottom = b; });
    root.style.setProperty('--wc-pack-top', Math.round(bottom) + 'px');
  }
  padTop(); window.addEventListener('resize', padTop); window.addEventListener('load', padTop); setTimeout(padTop, 600); setTimeout(padTop, 2000);
  document.querySelectorAll('.section-site-header img').forEach(function (img) { if (!img.complete) img.addEventListener('load', padTop); });

  var tiers = [];
  try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); } catch (e) { tiers = []; }
  tiers = tiers.filter(function (t) { return t && t.size > 0; }).sort(function (a, b) { return a.size - b.size; });
  if (!tiers.length) return;
  var first = tiers[0], last = tiers[tiers.length - 1];
  var fmt = root.getAttribute('data-money-format') || '${{amount}}';
  var L = {
    pick: root.getAttribute('data-pick-label') || 'Pick {left} more to unlock {price} a pair',
    add: root.getAttribute('data-add-label') || 'Add {n} pairs',
    adding: root.getAttribute('data-adding-label') || 'Adding...',
    count: root.getAttribute('data-count-label') || '{picked} of {n} picked',
    hintFirst: root.getAttribute('data-hint-first') || '{left} more and every pair is {price}',
    hintNext: root.getAttribute('data-hint-next') || '{left} more and every pair drops to {price}',
    hintMax: root.getAttribute('data-hint-max') || 'Every pair is {price}. Add more at the same price.',
    unlocked: root.getAttribute('data-unlocked-label') || 'Unlocked',
    cap: root.getAttribute('data-cap-label') || '20 pairs is the max for one pack. Add these, then start another.',
    // customer words from the theme locale (wc.pack keys), printed on the section root; English fallbacks = the old literals
    picked: root.getAttribute('data-picked-label') || '{picked} pairs picked',
    reviews: root.getAttribute('data-reviews-label') || '{n} reviews',
    reviewsOne: root.getAttribute('data-reviews-one') || '{n} reviews',
    photo: root.getAttribute('data-photo-label') || 'Photo {n}',
    from: root.getAttribute('data-from-label') || 'from {price}',
    inPack: root.getAttribute('data-in-pack-label') || 'in a pack',
    soldOut: root.getAttribute('data-soldout-label') || 'Sold out. Get notified',
    error: root.getAttribute('data-error-label') || 'Something went wrong. Please try again.'
  };
  var goal = parseInt(root.getAttribute('data-default'), 10) || first.size;   // the size the slots count toward
  var picks = [];
  var busy = false;
  var lastRateSize = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-wc-pack-item]'));
  var byId = {};
  items.forEach(function (li) { byId[li.getAttribute('data-id')] = li; });
  var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-wc-pack-size]'));
  var slotsEl = root.querySelector('[data-wc-pack-slots]');
  var countEl = root.querySelector('[data-wc-pack-count]');
  var hintEl = root.querySelector('[data-wc-pack-hint]');
  var totalEl = root.querySelector('[data-wc-pack-total]');
  var compareEl = root.querySelector('[data-wc-pack-compare]');
  var addBtn = root.querySelector('[data-wc-pack-add]');
  var errEl = root.querySelector('[data-wc-pack-error]');
  var bar = root.querySelector('[data-wc-pack-bar]');
  // the section's single-pair price drives the hint and the button, like the milestone cards; the first card's price was a
  // trap (Unapologetic is $19.99 and would have said "$17 a pair" the day it sorted first)
  var basePrice = parseInt(root.getAttribute('data-base'), 10) || parseInt((items[0] && items[0].getAttribute('data-price')) || '1799', 10);

  function money(cents) {
    var v = Math.max(0, cents) / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.005;
    var n = whole ? String(Math.round(v)) : v.toFixed(2);
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator)?\s*\}\}/, n);
  }
  function fill(t, map) { return String(t).replace(/\{(n|left|picked|price)\}/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }   // locale text going into innerHTML
  function qtyOf(id) { var q = 0; picks.forEach(function (p) { if (p === id) q++; }); return q; }
  function current(count) { var c = null; tiers.forEach(function (t) { if (count >= t.size) c = t; }); return c; }
  function nextTier(count) { for (var i = 0; i < tiers.length; i++) if (tiers[i].size > count) return tiers[i]; return null; }
  function rateFor(t) { return money(Math.max(0, basePrice - t.off)); }

  function render() {
    var count = picks.length;
    var cur = current(count);
    var nxt = nextTier(count);
    var rateTier = cur || first;          // before the first line, the total counts at the first pack size's rate
    var off = rateTier.off;
    var total = 0, compare = 0;
    picks.forEach(function (id) { var li = byId[id]; if (!li) return; var p = parseInt(li.getAttribute('data-price'), 10) || 0; total += Math.max(0, p - off); compare += p; });

    // goal: what the slots count toward; it moves up on its own as lines are crossed
    if (goal < first.size) goal = first.size;
    if (count >= goal) goal = nxt ? nxt.size : last.size;
    var slots = Math.max(goal, Math.min(count, last.size));

    items.forEach(function (li) {
      var id = li.getAttribute('data-id');
      var q = qtyOf(id);
      var p = parseInt(li.getAttribute('data-price'), 10) || 0;
      li.classList.toggle('is-in', q > 0);
      var badge = li.querySelector('[data-wc-pack-badge]');
      if (badge) { badge.hidden = q === 0; badge.textContent = q > 1 ? ('x' + q) : '✓'; }
      var n = li.querySelector('[data-wc-pack-n]');
      if (n) n.textContent = String(q);
    });

    // milestone cards
    sizeBtns.forEach(function (b) {
      var size = parseInt(b.getAttribute('data-wc-pack-size'), 10);
      var hit = count >= size;
      var isCur = !!cur && cur.size === size;
      b.classList.toggle('is-hit', hit);
      b.classList.toggle('is-current', isCur);
      b.classList.toggle('is-goal', !hit && size === goal);
      b.setAttribute('aria-pressed', size === goal ? 'true' : 'false');
      var chip = b.querySelector('[data-wc-pack-chip]');
      if (chip) {
        if (hit) { chip.textContent = L.unlocked; chip.classList.add('is-unlocked'); }
        else { chip.classList.remove('is-unlocked'); chip.textContent = chip.classList.contains('is-popular') ? (chip.getAttribute('data-popular') || chip.textContent) : ''; }
      }
    });
    // the unlocked moment, once per line crossed upward
    if (cur && cur.size > lastRateSize) {
      var card = sizeBtns.filter(function (b) { return parseInt(b.getAttribute('data-wc-pack-size'), 10) === cur.size; })[0];
      if (card && !reduce) { card.classList.remove('is-unlocking'); void card.offsetWidth; card.classList.add('is-unlocking'); setTimeout(function () { card.classList.remove('is-unlocking'); }, 900); }
      if (bar && !reduce) { bar.classList.remove('is-pop'); void bar.offsetWidth; bar.classList.add('is-pop'); setTimeout(function () { bar.classList.remove('is-pop'); }, 700); }
    }
    lastRateSize = cur ? cur.size : 0;

    // slots
    if (slotsEl) {
      var html = '';
      for (var i = 0; i < slots; i++) {
        var id = picks[i];
        var li = id ? byId[id] : null;
        var img = li ? li.getAttribute('data-img') : '';
        html += '<li class="wc-pack__slot' + (li ? ' is-filled' : '') + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</li>';
      }
      if (count > slots) html += '<li class="wc-pack__slot wc-pack__slot--more">+' + (count - slots) + '</li>';
      slotsEl.innerHTML = html;
    }
    if (countEl) countEl.textContent = count > slots ? fill(L.picked, { picked: count }) : fill(L.count, { picked: count, n: slots });   // past the biggest pack, "8 of 7" reads wrong
    if (hintEl) {
      var hint;
      if (!cur) hint = fill(L.hintFirst, { left: first.size - count, price: rateFor(first) });
      else if (nxt) hint = fill(L.hintNext, { left: nxt.size - count, price: rateFor(nxt) });
      else hint = fill(L.hintMax, { price: rateFor(last) });
      hintEl.textContent = hint;
    }
    if (totalEl) totalEl.textContent = money(total);
    if (compareEl) { compareEl.hidden = !(compare > total); compareEl.textContent = money(compare); }
    if (addBtn) {
      addBtn.disabled = !cur;
      addBtn.textContent = cur ? fill(L.add, { n: count }) : fill(L.pick, { left: first.size - count, price: rateFor(first) });
    }
  }

  function say(msg) { if (!errEl) return; errEl.textContent = msg || ''; errEl.hidden = !msg; }
  // the pack survives a trip to a product page and back (photos and names open in a new tab, but people do come back through the drawer or the back button)
  var store; try { store = window.sessionStorage; } catch (e) { store = null; }
  function remember() { if (!store) return; try { if (picks.length) store.setItem('wc_pack_picks', JSON.stringify(picks)); else store.removeItem('wc_pack_picks'); } catch (e) {} }
  function recall() {
    if (!store) return;
    var saved = []; try { saved = JSON.parse(store.getItem('wc_pack_picks') || '[]'); } catch (e) { saved = []; }
    if (!Array.isArray(saved)) saved = [];
    saved.forEach(function (id) { var li = byId[id]; if (li && !li.classList.contains('is-out') && picks.length < 20) picks.push(id); });
  }
  function pick(id) { if (picks.length >= 20) { say(L.cap); return; } picks.push(id); say(''); remember(); render(); }
  function unpick(id) { for (var i = picks.length - 1; i >= 0; i--) { if (picks[i] === id) { picks.splice(i, 1); break; } } remember(); render(); }

  sizeBtns.forEach(function (b) { var chip = b.querySelector('[data-wc-pack-chip]'); if (chip) chip.setAttribute('data-popular', chip.textContent); });

  /* ---- quick look: a closer look at one style without leaving the pack ---- */
  var look = root.querySelector('[data-wc-pack-look-root]');
  var lookId = null, lookReturn = null;
  function starsHtml(rating, count) {
    var r = parseFloat(rating); if (!(r > 0) || !(count > 0)) return '';
    var pct = Math.round(r / 5 * 100);
    return '<span class="wc-stars" style="--wc-stars: ' + pct + '%" aria-hidden="true"><span class="wc-stars__bg">\u2605\u2605\u2605\u2605\u2605</span><span class="wc-stars__fg">\u2605\u2605\u2605\u2605\u2605</span></span><span class="wc-pack-look__rcount">' + fill(esc(count === 1 ? L.reviewsOne : L.reviews), { n: count }) + '</span>';
  }
  function openLook(li) {
    if (!look) return;
    lookId = li.getAttribute('data-id'); lookReturn = document.activeElement;
    var imgs = []; try { imgs = JSON.parse(li.getAttribute('data-images') || '[]'); } catch (e) { imgs = []; }
    var p = parseInt(li.getAttribute('data-price'), 10) || 0;
    var title = li.getAttribute('data-title') || '';
    var main = look.querySelector('[data-wc-pack-look-img]');
    if (main) { main.src = imgs[0] || li.getAttribute('data-img') || ''; main.alt = title; }
    var thumbs = look.querySelector('[data-wc-pack-look-thumbs]');
    if (thumbs) {
      thumbs.innerHTML = imgs.length > 1 ? imgs.map(function (u, i) { return '<button type="button" class="wc-pack-look__thumb' + (i === 0 ? ' is-on' : '') + '" data-src="' + u + '" aria-label="' + fill(esc(L.photo), { n: i + 1 }) + '"><img src="' + u + '" alt=""></button>'; }).join('') : '';
      thumbs.hidden = imgs.length < 2;
    }
    var el;
    if ((el = look.querySelector('[data-wc-pack-look-title]'))) el.textContent = title;
    if ((el = look.querySelector('[data-wc-pack-look-stars]'))) { el.innerHTML = starsHtml(li.getAttribute('data-rating'), parseInt(li.getAttribute('data-count'), 10) || 0); el.hidden = !el.innerHTML; }
    if ((el = look.querySelector('[data-wc-pack-look-price]'))) el.innerHTML = '<s>' + money(p) + '</s><b>' + fill(esc(L.from), { price: money(Math.max(0, p - last.off)) }) + ' ' + esc(L.inPack) + '</b>';
    if ((el = look.querySelector('[data-wc-pack-look-low]'))) {
      var lowText = li.getAttribute('data-low') || '';
      while (el.firstChild) el.removeChild(el.firstChild);
      if (lowText) { var dot = document.createElement('span'); dot.className = 'wc-low__dot'; dot.setAttribute('aria-hidden', 'true'); el.appendChild(dot); el.appendChild(document.createTextNode(lowText)); }
      el.hidden = !lowText;
    }
    if ((el = look.querySelector('[data-wc-pack-look-desc]'))) { el.textContent = li.getAttribute('data-desc') || ''; el.hidden = !el.textContent; }
    if ((el = look.querySelector('[data-wc-pack-look-url]'))) el.href = li.getAttribute('data-url') || '#';
    var add = look.querySelector('[data-wc-pack-look-add]');
    var out = li.classList.contains('is-out');
    if (add) { add.hidden = out; }
    var details = look.querySelector('[data-wc-pack-look-url]');
    if (details) {
      if (!details.getAttribute('data-label')) details.setAttribute('data-label', details.textContent);   // cache the real label BEFORE any sold-out rewrite
      details.textContent = out ? L.soldOut : details.getAttribute('data-label');
    }
    look.hidden = false; document.body.classList.add('wc-pack-look-open');
    var panel = look.querySelector('.wc-pack-look__panel'); if (panel) { panel.scrollTop = 0; panel.focus(); }
  }
  function closeLook() {
    if (!look || look.hidden) return;
    look.hidden = true; document.body.classList.remove('wc-pack-look-open');
    if (lookReturn && lookReturn.focus) lookReturn.focus();
    lookId = null;
  }
  if (look) {
    look.addEventListener('click', function (evt) {
      var t = evt.target; if (!t || !t.closest) return;
      if (t.closest('[data-wc-pack-look-close]')) { closeLook(); return; }
      var th = t.closest('.wc-pack-look__thumb');
      if (th) { var main = look.querySelector('[data-wc-pack-look-img]'); if (main) main.src = th.getAttribute('data-src'); look.querySelectorAll('.wc-pack-look__thumb').forEach(function (b) { b.classList.toggle('is-on', b === th); }); return; }
      if (t.closest('[data-wc-pack-look-add]')) { if (lookId) pick(lookId); closeLook(); return; }
    });
    document.addEventListener('keydown', function (evt) { if (evt.key === 'Escape') closeLook(); });
  }

  root.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var lk = t.closest('[data-wc-pack-look]');
    if (lk && look) { var li0 = lk.closest('[data-wc-pack-item]'); if (li0) { evt.preventDefault(); openLook(li0); return; } }
    var sb = t.closest('[data-wc-pack-size]');
    if (sb) { goal = parseInt(sb.getAttribute('data-wc-pack-size'), 10) || goal; say(''); render(); return; }
    var li = t.closest('[data-wc-pack-item]');
    if (li) {
      var id = li.getAttribute('data-id');
      if (t.closest('[data-wc-pack-pick]') || t.closest('[data-wc-pack-plus]')) { evt.preventDefault(); pick(id); return; }
      if (t.closest('[data-wc-pack-minus]')) { evt.preventDefault(); unpick(id); return; }
    }
  });

  if (addBtn) addBtn.addEventListener('click', function () {
    if (busy || !current(picks.length)) return;
    var map = {}; picks.forEach(function (id) { map[id] = (map[id] || 0) + 1; });
    // every line from the builder carries a hidden property (underscore = not shown to the shopper) with the
    // pack size reached at add time, so orders can be told apart in admin and tagged by Shopify Flow
    var props = { _wc_pack: current(picks.length).size + ' pairs' };
    var lines = Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id], properties: props }; });
    busy = true; addBtn.setAttribute('aria-busy', 'true'); addBtn.textContent = L.adding; say('');
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {   // locale-aware root: /es/ on Spanish pages
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: lines, sections: 'cart-items,cart-footer,cart-item-count', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || data.message || '');
        document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: { response: data } }));
        if (window.Alpine && Alpine.store && Alpine.store('modals')) Alpine.store('modals').open('cart');
        picks = []; lastRateSize = 0; goal = parseInt(root.getAttribute('data-default'), 10) || first.size; remember();
      })
      .catch(function (err) { say((err && err.message) || L.error); })
      .then(function () { busy = false; addBtn.removeAttribute('aria-busy'); render(); });
  });

  // the fixed bar's real height feeds the page padding (an error line or a long slot row makes it taller than the CSS guess)
  if (bar && window.ResizeObserver) {
    new ResizeObserver(function () {
      if (getComputedStyle(bar).position === 'fixed') root.style.setProperty('--wc-bar-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
      else root.style.removeProperty('--wc-bar-h');
    }).observe(bar);
  }

  recall();
  var recalled = current(picks.length); lastRateSize = recalled ? recalled.size : 0;   // a recalled pack must not replay the unlocked moment
  render();
})();
